<template>
  <div class="login-wrapper">
    <div class="middle-box text-center">
      <div>
        <img width="80%" src="../../../public/img/sgo-atendimento.png" alt="logo">
      </div>

      <h4 class="mt-4 mb-3 font-bold" style="color: #0b2545;">Bem-Vindo</h4>
      <p class="text-muted auth-sub-text mx-auto mb-4" style="font-size: 0.9em;">
        Vamos efetuar o seu login. Digite seu e-mail e cpf para continuar.
      </p>

      <form @submit.prevent="loginCrm" id="form-principal" class="m-t" role="form">
        <div class="form-group text-left mb-4">
          <InputGroup size="small">
            <InputGroupAddon>
              <i class="pi pi-at"></i>
            </InputGroupAddon>
            <FloatLabel variant="on" v-focustrap>
              <InputText id="email" v-model="emailCliente" size="small" style="width: 100%"
                         autocomplete="username" autofocus/>
              <label for="email"><strong>E-mail: </strong></label>
            </FloatLabel>
          </InputGroup>
        </div>
        <div class="form-group text-left mb-4">
          <InputGroup size="small">
            <InputGroupAddon>
              <i class="pi pi-id-card"></i>
            </InputGroupAddon>
            <FloatLabel variant="on">
              <InputMask id="password" v-model="cpfCliente" size="small" style="width: 100%" :mask="'999.999.999-99'"/>
              <label for="password"><strong>CPF: </strong></label>
            </FloatLabel>
          </InputGroup>
        </div>
        <div class="form-group text-center mb-4 d-flex justify-content-center">
          <Recaptcha ref="recaptcha" :siteKey="turnstileSiteKey" @verify="onCaptchaVerify" />
        </div>
        <div class="form-group">
          <button type="submit" class="btn btn-primary full-width m-b w-100 font-bold p-2">Entrar</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import {apiUrl} from "@/router/apiBackRoutes";
import Recaptcha from "@/components/Recaptcha.vue";

export default {
  name: "LoginCrm",
  components: {
    Recaptcha
  },
  data() {
    return {
      emailCliente: "",
      cpfCliente: "",
      turnstileSiteKey: process.env.VUE_APP_TURNSTILE_SITE_KEY,
      turnstileToken: null,
    }
  },
  methods: {
    onCaptchaVerify(token) {
      this.turnstileToken = token;
    },
    resetCaptcha() {
      this.turnstileToken = null;
      if (this.$refs.recaptcha && typeof this.$refs.recaptcha.reset === "function") {
        this.$refs.recaptcha.reset();
      }
    },
    async loginCrm() {
      if (!this.turnstileToken) {
        this.$toastMessage("warn", "Atenção", "Por favor, resolva a verificação de segurança antes de entrar.");
        return;
      }
      try {
        const response = await fetch(apiUrl.crm.login, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'include',
          body: JSON.stringify({
            email: this.emailCliente,
            cpf: this.cpfCliente,
            "cf-turnstile-response": this.turnstileToken,
          }),
        });

        const data = await response.json();
        if (response.ok) {
          localStorage.setItem('crm_clienteLogado', true);
          localStorage.setItem('crm_clienteId', data.cliente_id);
          localStorage.setItem('crm_clienteNome', data.cliente_nome);
          localStorage.setItem('crm_isAuthenticated', true);

          this.$router.push('/crm/solicitacoes');
          this.$toastMessage("success", "Login realizado com sucesso!");
        } else {
          this.$toastMessage("warn", "Atenção", data.erro || "Erro de login");
          this.resetCaptcha();
        }
      } catch (error) {
        console.error('Erro na requisição:', error);
        this.resetCaptcha();
      }
    },
  },
}
</script>

<style scoped>
.login-wrapper {
  background-image: url('../../../public/img/login-crm.jpg');
  background-size: cover;
  background-position: center;
  font-family: Arial, sans-serif;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;
}

.middle-box {
  background-color: rgba(255, 255, 255, 0.8);
  padding: 30px;
  border-radius: 50px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  width: 350px;
}
</style>
